export const ERROR_CODES = {
  ANSWER_NOT_IN_CONTEXT: 'ANSWER_NOT_IN_CONTEXT',
};

export const ERROR_MESSAGES = {
  ANSWER_NOT_IN_CONTEXT: 'Answer not in the given context',
};
